<template>
  <div class="">
    <div class="cart_wrap bg_white mt12">
      <p class="cart_title ab c5a">新しく選択した定期購入リスト合計</p>
      <div class="price_wrap">
        <p class="price_sum rm" v-model="this.bcTotalPrice"><span class="yen ab">￥</span>{{ this.bcTotalPrice.toLocaleString() }}</p>
        <p class="cart_point rm" v-model="this.bcTotalPoint"><span class="point ab">ポイント：</span>{{ this.bcTotalPoint.toLocaleString() }}<span class="cart_pt ab">pt</span></p>
      </div>
    </div>
    <div class="item_wrap bg_white pt16">
      <div v-if="this.cartItems.length != 0">
        <div class="mb20" v-for="(value, l) in cartItems" :key="l">
          <div v-if="value.bcItemList.length > 0">
            <h2 class="content_title">購入BC</h2>
            <div class="pl16 pr16 mt24">
              <h3 class="nowBC rb c5a bdb">BC：<span class="bc_number rb">{{ value.bcNo }}</span></h3>
            </div>
            <div class="select_item bdb" v-for="(item, m) in value.bcItemList" :key="m">
              <div class="image_wrap">
                <div class="select_image">
                  <img :src="imagePath + item.product.imagePath" :alt="item.product.productName" v-on:error="imageError" :data-noimage="imagePath + item.product.noImagePath">
                </div>
                <p class="select_item--title ab">{{ item.product.productName }}</p>
                <button v-if="item.product.genre.genreId != 3" class="delete btn_delete btn_mini" v-on:click="updateCart(l, m, 'delete')">削除</button>
              </div>
              <div class="select_contents">
                <div class="manth_wrap">
                  <div class="month_item">
                    <p class="month ab c5a">定期購入</p>
                    <div class="count_wrap">
                      <span class="count ab c5a">数量</span>
                      <div v-if="item.product.genre.genreId != 3" class="bottom_arrow select_count">
                        <select name="buy_count" class="c5a rb" v-on:change="updateCart(l, m, item.orderCount)" v-model="item.orderCount">
                          <option v-for="i of 10" :value="i" :key="i">{{ i }}</option>
                        </select>
                      </div>
                      <div v-else class="select_count"><p class="c5a rb">{{ item.orderCount }}</p></div>
                    </div>
                  </div>
                </div>
                <div v-if="item.product.genre.genreId != 3" class="kodomo_wrap">
                  <input class="kodomo_check" type="checkbox" v-bind:id="'kodomo' + l + m" name="checkbox01" v-on:change="updateCart(l, m, item.childFund)" v-model="item.childFund" v-bind:checked="item.childFund">
                  <label v-bind:for="'kodomo' + l + m" class="checkbox01 ab c5a">こども基金を支援する</label>
                </div>
                <div class="select_price">
                  <p class="item_price rm c5a"><span class="yen ab">￥</span>{{ item.childFund ? ((item.product.price * item.orderCount) + (100 * item.orderCount)).toLocaleString() : (item.product.price * item.orderCount).toLocaleString() }}</p>
                  <p class="item_point rm c5a"><span class="point_text ab">ポイント：</span>{{ (item.product.point * item.orderCount).toLocaleString() }}<span class="point ab">pt</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cart_none" v-else>
        <p class="rb c5a">現在、定期購入されている商品はありません。</p>
      </div>
    </div>

    <div class="service_wrap bg_white pt16 pb48 mt12">
      <button class="btn_blue" @click="confirmAndNext">次へ</button>
      <router-link class="btn_delete" :to="{ name: 'multiSubSelectProducts' }">戻る</router-link>
    </div>
    <ErrorModal v-show="isModalOpen" :errorMessage="errorMessage" @modalClose="modalClose" />
  </div>
</template>

<script>
import Config from '@/config/config'
import CheckOrder from '@/model/checkSelectMultiRepeatOrder'
import RepeatOrder from '@/components/api/repeatOrder'
import { mapGetters } from 'vuex'
import ErrorModal from '@/components/common/ErrorModal'
import scrollPosition from '@/model/scrollPosition'

export default {
  components: {
    ErrorModal
  },
  data () {
    return {
      imagePath: Config.APIURL,
      cart: true,
      cartItems: [],
      bcTotalPrice: 0,
      bcTotalPoint: 0,
      change: true,
      isModalOpen: false,
      errorMessage: '商品が選択されていません'
    };
  },
  methods: {
    imageError(e) {
      e.target.src = e.target.dataset.noimage;
    },
    createData () {
      this.bcTotalPrice = 0;
      this.bcTotalPoint = 0;
      this.cartItems.splice(0, this.cartItems.length);
      let items = JSON.parse(localStorage.getItem('recommendationRepeatItemList'));

      if (items) {
        for (var i = 0; i < items.length; i++) {
          var cartItem = {
            bcNo: items[i].bcNo,
            bcItemList: []
          };
          var bcItemList = items[i].bcItemList;

          for (var j = 0; j < bcItemList.length; j++) {
            var itemList = bcItemList[j].itemList;

            for (var k = 0; k < itemList.length; k++) {
              if (itemList[k].repeatOrder) {
                cartItem.bcItemList.push(itemList[k]);
              }
            }
          }
          this.cartItems.push(cartItem);
        }
      }

      if(this.cartItems.length != 0) {
        for (var i = 0; i < this.cartItems.length; i++) {
          for (var j = 0; j < this.cartItems[i].bcItemList.length; j++) {
            var bcItem = this.cartItems[i].bcItemList[j];
            let totalPrice = bcItem.product.price * bcItem.orderCount;
            let totalPoint = bcItem.product.point * bcItem.orderCount;
            this.bcTotalPrice = this.bcTotalPrice + totalPrice;
            this.bcTotalPoint = this.bcTotalPoint + totalPoint;
            if (bcItem.childFund) {
              this.bcTotalPrice = this.bcTotalPrice + (100 * bcItem.orderCount);
            }
          }
        }
      }
    },
    updateCart (l, m, data) {
      let repeatItemList = JSON.parse(localStorage.getItem('recommendationRepeatItemList'));
      if(repeatItemList) {
        for (var i = 0; i < repeatItemList.length; i++) {
          // BCNoが一致するかチェック
          if(repeatItemList[i].bcNo != this.cartItems[l].bcNo) {
            continue;
          }
          var bcItemList = repeatItemList[i].bcItemList;
          for (var a = 0; a < bcItemList.length; a++) {
            var itemList = bcItemList[a].itemList;
            for (var k = 0; k < itemList.length; k++) {
              if(itemList[k].product.productId == this.cartItems[l].bcItemList[m].product.productId) {
                if(Number.isInteger(data)) {
                  // 購入数の変更
                  itemList[k].orderCount = data;
                } else if(data == 'delete') {
                  // 削除
                  itemList[k].repeatOrder = false;
                  itemList[k].orderCount = 1;
                  itemList[k].childFund = false;
                } else {
                  // 子供基金の変更
                  itemList[k].childFund ? itemList[k].childFund = false : itemList[k].childFund = true;
                }
              }
            }
          }
        }
      }
      localStorage.setItem('recommendationRepeatItemList', JSON.stringify(repeatItemList));
      this.createData();
      let result = CheckOrder.checkSelectRepeatOrder();
      this.setSubscriptioncheckSelectRepeatOrder(result);
    },
    setSubscriptioncheckSelectRepeatOrder(result) {
      this.$store.commit('setSubscriptioncheckSelectRepeatOrder', result);
    },
    // Vuexから推奨商品データを処理
    processRecommendProducts() {
      const recommendProducts = this.recommendationRecommendProductMap;

      if (recommendProducts && Object.keys(recommendProducts).length > 0) {
        // 推奨商品を画面用のデータ構造に変換
        for (const bcNo in recommendProducts) {
          if (recommendProducts[bcNo].repeatOrdersList) {
            const cartItem = {
              bcNo: bcNo,
              bcItemList: recommendProducts[bcNo].repeatOrdersList
            };
            this.cartItems.push(cartItem);
          }
        }

        // 合計金額とポイントを計算
        this.calculateTotals();
      }
    },
    calculateTotals() {
      this.bcTotalPrice = 0;
      this.bcTotalPoint = 0;

      for (const cartItem of this.cartItems) {
        for (const item of cartItem.bcItemList) {
          const totalPrice = item.product.price * item.orderCount;
          const totalPoint = item.product.point * item.orderCount;
          this.bcTotalPrice += totalPrice;
          this.bcTotalPoint += totalPoint;

          if (item.childFund) {
            this.bcTotalPrice += (100 * item.orderCount);
          }
        }
      }
    },
    async confirmAndNext() {
      // 選択された商品があるか確認
      if (this.cartItems.length === 0) {
        this.errorMessage = '選択された商品がありません。';
        this.modalOpen();
        return false;
      }

      try {
        // 全BCの設定情報を一度に取得（重複するBC向けの最適化）
        const uniqueBCs = [...new Set(this.cartItems.map(item => item.bcNo))];
        const bcSettingsMap = {};

        // 購入注文設定を取得（localStorage → Vuex の優先順位）
        const getValidPurchaseSettings = () => {
          // localStorageから取得
          const stored = localStorage.getItem('recommendationPurchaseSettings');
          if (stored) {
            return JSON.parse(stored);
          }

          // フォールバック: Vuexから取得
          const vuexSettings = this.recommendationPurchaseSettings || {};
          return vuexSettings;
        };

        const purchaseSettings = getValidPurchaseSettings();
        const paymentMethodId = purchaseSettings.paymentMethodId;
        const deliveryTimeId = purchaseSettings.deliveryTimeId;

        // 全BCの設定を並行して取得
        const bcSettingsPromises = uniqueBCs.map(async (bcNo) => {
          try {
            // denyCreditDeliveryFlagとavailableBulkSettingのみRepeatOrder APIから取得
            const [creditDeliveryResponse, deliveryResponse] = await Promise.all([
              RepeatOrder.getDenyCreditDelivery(bcNo),
              RepeatOrder.repeatGetDeliveryTimeList(bcNo)
            ]);

            const denyCreditDeliveryFlag = creditDeliveryResponse.denyCreditDeliveryFlag;
            const availableBulkSetting = deliveryResponse.availableBulkSetting !== undefined ?
              deliveryResponse.availableBulkSetting : true;

            bcSettingsMap[bcNo] = {
              paymentMethodId: paymentMethodId,
              deliveryTimeId: deliveryTimeId,
              denyCreditDeliveryFlag: denyCreditDeliveryFlag,
              availableBulkSetting: availableBulkSetting
            };

          } catch (apiError) {
            console.warn(`API取得失敗 BC:${bcNo}, フォールバック値を使用:`, apiError);
            // APIエラーの場合は購入設定、次にデフォルト値を使用
            bcSettingsMap[bcNo] = {
              paymentMethodId: paymentMethodId,
              deliveryTimeId: deliveryTimeId,
              denyCreditDeliveryFlag: false,
              availableBulkSetting: true
            };
          }
        });

        await Promise.all(bcSettingsPromises);

        // 各カートアイテムの注文データを作成
        const multiBcOrderData = {};
        for (const cartItem of this.cartItems) {
          const bcNo = cartItem.bcNo;
          const settings = bcSettingsMap[bcNo];

          multiBcOrderData[bcNo] = {
            bcNo: bcNo,
            repeatOrderList: cartItem.bcItemList.map(item => ({
              product: {
                genre: item.product.genre || {
                  genreId: 1,
                  genreName: "ヘルスケア製品"
                },
                productId: item.product.productId,
                productName: item.product.productName,
                price: item.product.price,
                point: item.product.point,
                imagePath: item.product.imagePath,
                noImagePath: item.product.noImagePath,
                maxCount: item.product.maxCount || 10,
                selectableChildFund: item.product.selectableChildFund !== undefined ? item.product.selectableChildFund : true
              },
              categoryName: item.categoryName || "",
              orderCount: item.orderCount,
              childFund: item.childFund,
              repeatOrder: item.repeatOrder || false,
              stopOrder: item.stopOrder || false
            })),
            paymentMethodId: settings.paymentMethodId,
            deliveryTimeId: settings.deliveryTimeId,
            denyCreditDeliveryFlag: settings.denyCreditDeliveryFlag,
            isAvailableBulkSetting: settings.availableBulkSetting || false
          };
        }

        // Vuexに保存
        this.$store.commit('setRecommendationMultiBcOrderData', multiBcOrderData);

        // 次の画面へ遷移
        this.$router.push({ name: 'multiShippingPlan' });
      } catch (error) {
        this.errorMessage = 'API設定の取得に失敗しました。デフォルト設定で続行します。';
        this.modalOpen();
      }
    },
    modalOpen() {
      scrollPosition.open();
      this.isModalOpen = true;
    },
    modalClose() {
      scrollPosition.close();
      this.isModalOpen = false;
    }
  },
  computed: mapGetters([
    'recommendationRecommendProductMap',
    'recommendationPurchaseSettings'
  ]),
  created () {
    this.createData();
    if (this.cartItems.length === 0) {
      this.processRecommendProducts();
    }
  },
};
</script>

<style lang="css" scoped>

.content_title {
  width: 241px;
}

.nowBC {
  font-size: 20px;
  line-height: 1;
  padding-bottom: 7px;
}
/* カートに商品がない場合 */
.cart_none {
  font-size: 14px;
  padding: 69px 0;
  text-align: center;
}
/* カート中身 */
.detail_wrap {
  padding-top: 74px;
}

.cart_wrap {
  border-bottom: 1px solid #c9c9c9;
  padding: 24px 16px 10px;
}

.cart_title {
  border-left: 4px solid  #4FCCD4;
  font-size: 18px;
  padding-left: 4px;
}

.price_wrap {
  color: #009FA9;
  margin-top: 25px;
  text-align: right;
}

.price_sum {
  font-size: 28px;
}

.yen {
  font-size: 22px;
}

.cart_point {
  font-size: 18px;
}

.point {
  font-size: 14px;
}

.cart_pt {
  font-size: 14px;
}

.cart_tab input {
  display: none;
}

.cart_tab {
  border-bottom: 1px solid  #aaa;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.cart_tab .tab {
  border: solid #AAAAAA;
  border-width: 1px 1px 0;
  border-radius: 12px 12px 0 0;
  background-color: #f4f4f4;
  color: #A3A3A3;
  font-size: 20px;
  padding: 9px 0 8px 16px;
  width: 49.9%;
}

.cart_tab .tab.isActive {
  background-color: #fff;
  color: #5a5a5a;
}

.other_bc {
  border-bottom: 1px solid  #c9c9c9;
  display: flex;
  justify-content: space-between;
  padding: 37px 16px 25px;
}
.bc_number {
  font-size: 20px;
}

.other_number--detail {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
}
.other_bc--price {
  font-size: 26px;
}
.yen {
  font-size: 20px;
}
.btn_mini {
  margin: 16px 0 0;
}

.select_item {
  border-bottom: 1px solid  #c9c9c9;
  display: flex;
  justify-content: space-between;
  padding: 25px 15px 24px 24px;
}
.image_wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  width: 33%;
}

/* .select_image {
  // 必要なスタイルがあればここに記述
} */

.month_item {
  align-items: flex-end;
  display: flex;
}

.count_wrap {
  align-items: flex-end;
  display: flex;
  margin-left: 20px;
  width: 56%;
}

.select_item--title {
  font-size: 12px;
  margin-top: 5px;
}
.btn_delete {
  margin: 21px auto 0;
}

.select_contents {
  margin-top: 10px;
  width: 59%;
}

.manth_wrap {
  margin-top: 0;
}

.month {
  font-size: 16px;
  line-height: 1;
}

.month_number {
  font-size: 22px;
}

.count {
  font-size: 14px;
  line-height: 1;
}

.select_count {
  border-bottom: 1px solid #5a5a5a;
  margin-left: 8px;
  /* width: 70%; */
  width: 63%;
}
.select_count:after {
  bottom: 6px;
  right: 0;
}
.select_count select,
.select_count p {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-size: 26px;
  padding-left: 23px;
  width: 100%;
}



.checkbox01 {
  display: flex;
  font-size: 14px;
  justify-content: flex-end;
  margin-top: 35px;
  padding: 5px 0 5px 30px;
}

.checkbox01::before {
  left: 0;
}

.checkbox01::after {
  left: 5px;
}

.select_price {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  margin-top: 34px;
}

.item_price {
  font-size: 26px;
}

.yen {
  font-size: 20px;
}

.item_point {
  font-size: 16px;
}

.point_text {
  font-size: 12px;
}

.select_sum {
  display: block;
  margin-top: 0;
  padding: 24px 15px;
}

.select_sum .item_price {
  margin-top: 0;
}

.select_sum .subtotal {
  font-size: 14px;
}

.btn_blue {
  margin-top: 32px;
}
</style>



// WEBPACK FOOTER //
// src/views/subscriptionMultiBc/SubSelectProductsList.vue